import React from 'react';
import styled from 'styled-components';
const Content = styled.div`
    width: 1440px;
    height: 768px;
    padding-top: var(--top-spacing);
    background-repeat: no-repeat;
    min-height: calc(100vh - var(--top-spacing));
    display: flex;
    overflow: auto;
    flex-direction: column;
    align-items: center;
`;

const Message = styled.p`
  font-size: 20px;
  margin-top: 0.5em;
  margin-bottom: 0.5em;
  font-weight: bold;
  text-align: center;
`;

const SubMessage = styled.p`
  font-size: 16px;
  text-align: center;
  margin-top: 0.5em;
`;

export default class ErrorPage extends React.Component {

	render() {

	    return (
		    	<Content>
			     	<Message>Oops! Looks like you have come to the wrong please.</Message>
			      <SubMessage>Please make sure the URL is correct and try again.</SubMessage>
			    </Content>
		  );
	}
  
}